<div [ngStyle]="{ 'display' : navaidsCoChannelService.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <div class="fields__block" style="width: 100%">
    <div class="fields__block__section">
      <div class="table-fields">
        <div style="width: fit-content; margin: 0 auto;">
          <table style="display: block;width: 100%;">
            <thead>
              <tr>
                <th scope="col" style="width: 200px;">ID</th>
                <th scope="col" style="width: 200px;">Name</th>
                <th scope="col" style="width: 200px;">Type</th>
                <th scope="col" style="width: 200px;">Icao CC</th>
                <th scope="col" style="width: 200px;">Published</th>
                <th scope="col" style="width: 200px;">Latitude</th>
                <th scope="col" style="width: 200px;">Longitude</th>
                <th scope="col" style="width: 200px;">Distance {{this.navaidsCoChannelService.horizontalUnits}}</th>
                <th scope="col" style="width: 200px;">Azimuth [Deg]</th>
              </tr>
            </thead>
            <tbody style="max-height: 330px; overflow-y: auto; display: block; width: 100%;">
              <tr mdbTableCol *ngFor="let id of this.navaidsCoChannelService.frequencies; let iFreq = index">
                <div style="flex-direction: column">
                  <label
                    [ngClass]="[
                      this.navaidsCoChannelService.frequenciesActive[iFreq] ? 'active' : '',
                      this.navaidsCoChannelService.frequenciesActive[iFreq] ? 'colapsable' : 'colapsable'
                    ]"
                    for=""
                    (click)="colapsableLabelFrequency(iFreq)"
                    for=""
                    >{{id}} </label
                  >
                </div>
                <ng-container *ngIf="this.navaidsCoChannelService.frequenciesActive[iFreq]">
                  <tr *ngFor="let navaid of this.navaidsCoChannelService.sameFrequencyNavaids[iFreq]; let iNav = index"
                  (click)="navaidsCoChannelService.onClickNavaid(iFreq, iNav, $event)" [class.highlighted]="navaid.isselected">
                    <td style="width: 200px;">{{navaid.navaidid}}</td>
                    <td style="width: 200px;">{{navaid.name}}</td>
                    <td style="width: 200px;">{{navaid.navaidtype}}</td>
                    <td style="width: 200px;">{{navaid.icaocc}}</td>
                    <td style="width: 200px;">{{navaid.userdefined}}</td>
                    <td style="width: 200px;">{{navaid.latitude}}</td>
                    <td style="width: 200px;">{{navaid.longitude}}</td>
                    <td style="width: 200px;" *ngIf="this.navaidsCoChannelService.distances[iFreq][iNav]!=null">
                      {{this.navaidsCoChannelService.distances[iFreq][iNav]}}
                    </td>
                    <td style="width: 200px;" *ngIf="this.navaidsCoChannelService.distances[iFreq][iNav]==null"></td>
                    <td style="width: 200px;" *ngIf="this.navaidsCoChannelService.azimuth[iFreq][iNav]!=null">
                      {{this.navaidsCoChannelService.azimuth[iFreq][iNav]}}
                    </td>
                    <td style="width: 200px;" *ngIf="this.navaidsCoChannelService.azimuth[iFreq][iNav]==null"></td>
                  </tr>
                </ng-container>

              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
  <div class="fields__btn">
    <button class="gray" (click)="openOverlapPopup()">
      Calculate Overlap
    </button>
    <button class="gray" (click)="open8dbBoundaryPopup()">Draw 8dB Boundary</button>
  </div>
</div>
